import { Injectable } from '@angular/core'
import moment from 'moment/moment'

@Injectable({
  providedIn: 'root',
})
export class ContractDateService {
  private static readonly subsidizedPeriodYears = 20
  private validStartDates: moment.Moment[] = []
  private validEndDates: moment.Moment[] = []

  static isEndDateInSubsidizedPeriod(
    commissioningDate: moment.Moment | null,
    contractEndDate: moment.Moment | null
  ): boolean {
    if (!commissioningDate || !contractEndDate) {
      return true
    }
    const subsidizedPeriodEnd = commissioningDate
      .clone()
      .startOf('year')
      .add(ContractDateService.subsidizedPeriodYears, 'years')
      .endOf('year')
    return contractEndDate.isSameOrBefore(subsidizedPeriodEnd)
  }

  calculateValidEndDates(startDate: moment.Moment | null, isAlreadyInOperation: boolean | null) {
    if (!startDate || isAlreadyInOperation === null) {
      this.validEndDates = []
    } else {
      const monthsMin = isAlreadyInOperation ? 12 : 16
      const monthsMax = isAlreadyInOperation ? 24 : 29
      const minDate = startDate.clone().startOf('day').add(monthsMin, 'months').subtract(1, 'day')
      const maxDate = startDate.clone().startOf('day').add(monthsMax, 'months')
      const current = minDate.clone().month(11).date(31)
      const dates: moment.Moment[] = []
      while (current.isSameOrBefore(maxDate, 'day')) {
        dates.push(current.clone())
        current.add(1, 'year').month(11).date(31)
      }
      this.validEndDates = dates
    }
    return this.validEndDates
  }

  calculateValidStartDates(today: moment.Moment = moment()): moment.Moment[] {
    const todayDayStart = today.clone().startOf('day')
    const minDate = todayDayStart.clone().add(6, 'weeks')
    if (minDate.date() !== 1) {
      minDate.add(1, 'month').date(1)
    }
    const maxDate = todayDayStart.clone().add(6, 'months').date(1)
    this.validStartDates = []
    const current = minDate.clone()
    while (current.isSameOrBefore(maxDate, 'month')) {
      this.validStartDates.push(current.clone())
      current.add(1, 'month')
    }
    return this.validStartDates
  }

  findEndDateInSubsidizedPeriod(commissioningDate: moment.Moment): moment.Moment | null {
    return (
      this.validEndDates.find((date) =>
        ContractDateService.isEndDateInSubsidizedPeriod(moment(commissioningDate), date)
      ) || null
    )
  }

  findStartDateOutsideSubsidizedPeriod(commissioningDate: moment.Moment, selectedStartDate: moment.Moment) {
    const subsidizedPeriodStart = commissioningDate.clone().startOf('year')
    const subsidizedPeriodEnd = subsidizedPeriodStart
      .clone()
      .add(ContractDateService.subsidizedPeriodYears, 'years')
      .endOf('year')
    if (selectedStartDate.isAfter(subsidizedPeriodEnd)) {
      return selectedStartDate
    }
    return this.validStartDates.find((startDate) => startDate.isAfter(subsidizedPeriodEnd)) || null
  }
}
